export default "__VITE_ASSET__l1Sd_Cajay5XdkGmaL$idw__"